<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <sun-create-or-update v-model="sun"></sun-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { CampaignProductApi } from '@/api/campaign-product'
import SunCreateOrUpdate from './components/SunCreateOrUpdate.vue'
export default {
    components:{
        BCard,
        SunCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            fields:[
                {name:'Kod',key:'Code',sortable:true, thClass:'w-20'},
                {name:'İsim',key:'Name',sortable:true, thClass:'w-80'}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            sun:{
                Id:null,
                Name: null,
                Code: null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.sun.Id = null
            this.sun.Name = null
            this.sun.Code= null
        },
        provider(data){
            return CampaignProductApi.Sun.Table(data)
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.sun.Id = item.Id
            this.sun.Name = item.Name
            this.sun.Code = item.Code
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            CampaignProductApi.Sun.CreateOrUpdate(this.editing,this.sun).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} adlı ürünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    CampaignProductApi.Sun.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>